import { axiosV2 } from "config/@axios";
import {
  credentialToJSON,
  isWebAuthnSupported,
  PasskeyError,
  toCreationOptions
} from "utils/helpers/webauthn";

// Re-exported so callers of this module keep reaching it as Actions.PasskeyError.
export { PasskeyError };

export const FETCHING = "passkeysActions::fetching";
export const SET_ERROR_MESSAGE = "passkeysActions::setErrorMessage";
export const FETCH_SUCCESS = "passkeysActions::fetchSuccess";
export const RESET = "passkeysActions::reset";

export const fetch = () => dispatch => {
  dispatch({ type: FETCHING });
  return axiosV2
    .get("passkeys")
    .then(response => {
      dispatch({
        type: FETCH_SUCCESS,
        payload: response.data
      });
    })
    .catch(err => {
      dispatch({
        type: SET_ERROR_MESSAGE,
        payload: err.errorMessage
      });
    });
};

// Passkey registration ceremony: get the options, have the browser sign them,
// then verify. The password is checked while issuing the options, so a wrong
// one fails before the device prompt instead of leaving an orphan credential on
// the authenticator.
export const register = (name, password) => async () => {
  if (!isWebAuthnSupported()) {
    throw new PasskeyError("settings:passkeys.errors.not_supported");
  }

  const { data: options } = await axiosV2.post(
    "login/passkey/_register_options",
    { password }
  );

  const credential = await navigator.credentials.create({
    publicKey: toCreationOptions(options)
  });

  if (!credential) {
    throw new PasskeyError("settings:passkeys.errors.cancelled");
  }

  return axiosV2.post("login/passkey/_register_verify", {
    ...credentialToJSON(credential),
    name
  });
};
